import { Injectable } from '@angular/core';
import { TranslateDefaultParser } from '@ngx-translate/core';

@Injectable()
export class TranslateParserService extends TranslateDefaultParser {
  public interpolate(expr: string | Function, params?: any): string {
    return super.interpolate(expr, params);
  }
  public getValue(target: any, key: string) {
    const value = super.getValue(target, key);

    if (typeof value === 'object') {
      return key;
    }

    return value;
  }
}
